<!-- twc-button.component.html -->
<jmkw-popout-button
  #popoutButton
  [iconName]="iconName"
  [contentComponent]="componentRef"
  [tooltipText]="tooltipText"
  [active]="active"
  [automationKey]="automationKey"
></jmkw-popout-button>
